import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { logout } from '../../redux/modules/auth/auth-middleware';

class Logout extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.dispatch(logout());
  }

  render() {
    return (null);
  }
}

Logout.propTypes = {
  dispatch: PropTypes.func,
};

const mapStateToProps = (state) => ({
  patientId: state.profile.patient.patientId,
});

export default connect(mapStateToProps)(Logout);